<template>
  <!-- 填空题 -->
  <div class="question-item question-completion">
    <div class="title-box">
      <span class="line-name">答案</span>
      <span class="line-dec" v-if="!readOnly">请输入每个填空的答案</span>
      <!-- <el-switch
        :disabled="readOnly"
        v-model="unorder"
        active-text="答案乱序"
        style="float: right; padding: 10px"
        width="30"
      >
      </el-switch> -->
    </div>
    <div class="completion option">
      <div class="option-content">
        <div class="option-item" v-for="(item, index) in optionsCopy" :key="index">
          <div class="item-line1">
            <div class="item-order item-order-completion">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="item-text-completion">
              <el-input v-if="!readOnly" v-model="item['exam_questions_options.name']" placeholder="请输入内容" :maxlength="inputlength" />
              <el-input
                v-else
                :disabled="readOnly"
                :autosize="readOnly"
                v-model="item['exam_questions_options.name']"
                placeholder="请输入内容"
                type="textarea"
              />
            </div>
            <div class="item-del-completion" v-if="!readOnly">
              <i @click="delOption(item, index)" class="el-icon-error"></i>
              <i @click="upOption(item, index)" class="el-icon-top"></i>
              <i @click="downOption(item, index)" class="el-icon-bottom"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="option-add-completion" v-if="!readOnly">
        <DsfButton @click="addOption" type="plain" icon="add">添加填空</DsfButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfCompletion",
  mixins: [$mixins.examquestion],
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    exam_questions_options: {
      type: Array,
      // default: false,
    },

    saveStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // unorder: false,
    };
  },
  computed: {
    optionsCopy() {
      return this.exam_questions_options.filter((item) => item["exam_questions_options.ds_deleted"] !== 1);
    },
  },
  mounted() {
    this.exam_questions_options.forEach((item, index) => {
      this.$set(this.exam_questions_options[index], "exam_questions_options.ds_order", index);
      this.$set(this.exam_questions_options[index], "type", "completion");
    });
  },
  methods: {
    addOption() {
      var order = this.optionsCopy.length;
      if (order < this.maxNumbers) {
        this.exam_questions_options.push({
          "exam_questions_options.name": "",
          "exam_questions_options.ds_order": order,
          "exam_questions_options.is_right": { text: "是", value: 1 },
          type: "completion",
        });
      } else {
        dsf.layer.message(`填空数量最多为${this.maxNumbers}个`, false);
      }
    },
    upOption(item, index) {
      if (this.optionsCopy[index - 1]) {
        this.changeOrder(item, this.optionsCopy[index - 1]);
      }
    },
    downOption(item, index) {
      if (this.optionsCopy[index + 1]) {
        this.changeOrder(item, this.optionsCopy[index + 1]);
      }
    },
    changeOrder(curItem, otherItem) {
      var other_index = -1;
      var cur_index = -1;
      var other_row = [];
      this.exam_questions_options.forEach((ele, _index) => {
        if (ele["exam_questions_options.ds_order"] == otherItem["exam_questions_options.ds_order"]) {
          other_index = _index;
          other_row = ele;
        }
        if (ele["exam_questions_options.ds_order"] == curItem["exam_questions_options.ds_order"]) {
          cur_index = _index;
        }
      });
      var dsorder = other_row["exam_questions_options.ds_order"];
      this.$set(other_row, "exam_questions_options.ds_order", curItem["exam_questions_options.ds_order"]);
      this.$set(curItem, "exam_questions_options.ds_order", dsorder);
      this.$set(this.exam_questions_options, cur_index, other_row);
      this.$set(this.exam_questions_options, other_index, curItem);
    },

    delOption(item, index) {
      this.exam_questions_options.forEach((ele, index) => {
        if (ele["exam_questions_options.ds_order"] == item["exam_questions_options.ds_order"]) {
          if (item._id) {
            this.$set(this.exam_questions_options[index], "exam_questions_options.ds_deleted", 1);
            this.$delete(this.exam_questions_options[index], "exam_questions_options.ds_order");
          } else {
            this.exam_questions_options.splice(index, 1);
          }
        }
      });
      this.$emit("validate-single",false);
    },
    init() {
      for (let i = 0; i < this.minNumbers; i++) {
        this.exam_questions_options.push({
          "exam_questions_options.ds_order": i,
          "exam_questions_options.name": "",
        });
      }
    },
  },
  watch: {
    exam_questions_options: {
      handler(val) {
        if (val.length < 1) {
          // this.init();
        }
      },
      deep: true,
    },
    saveStatus(val) {
      if (val) {
        if (this.exam_questions_options.length < this.minNumbers) {
          dsf.layer.message(`请添加填空项，填空数量至少为${this.minNumbers}个`, false);
          this.$emit("set-savestatus", false);
          this.$emit("set-validatesuc", false);
          return false;
        }
        var hasNull = this.exam_questions_options.some((item) => !item["exam_questions_options.name"]);
        if (hasNull) {
          dsf.layer.message("请输入每个填空的答案", false);
          this.$emit("set-savestatus", false);
          this.$emit("set-validatesuc", false);
        }
      }
    },
  },
};
</script>

<style></style>
